/** Text styles and hash scrolling shared by the in-app user manuals. */
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const focus = 'focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-glow'
export const p = 'm-0 max-w-[70ch] text-[15px] leading-relaxed text-paper-dim'
export const ul = 'm-0 flex max-w-[70ch] list-disc flex-col gap-1.5 pl-5 text-[15px] leading-relaxed text-paper-dim'
export const ol = 'm-0 flex max-w-[70ch] list-decimal flex-col gap-1.5 pl-5 text-[15px] leading-relaxed text-paper-dim'

/** An in-page link inside a manual paragraph. */
export const link = `text-amber-glow underline underline-offset-2 hover:text-paper ${focus}`

/** Scroll to the section named by the URL hash, and again once fonts are in (they change the height above it). */
export function useHashScroll(): void {
  const { hash } = useLocation()
  useEffect(() => {
    if (!hash) return
    const go = () => document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView()
    go()
    let live = true
    void document.fonts?.ready.then(() => { if (live) go() })
    return () => { live = false }
  }, [hash])
}
